var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Dialog,{attrs:{"dialog":_setup.dlg,"dt":_setup.dt},scopedSlots:_vm._u([{key:"menu",fn:function({ item }){return [_c(_setup.ActionMenuItem,{attrs:{"action":`purchaseinvoice.open`},on:{"click":function($event){return _setup.dt.openDialog(item)}}}),_vm._t("menu")]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }